import React from 'react';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const StyledBox = styled(Box)({
  textAlign: 'center',
  position: 'fixed',
  left: '0',
  right: '0'
});

const StyledCircularProgress = styled(CircularProgress)({
  position: 'fixed',
  top: '50%',
  right: '50%',
  marginTop: '-20px',
  marginRight: '-20px'
});

function PageLoadSpinner() {
  return (
    <StyledBox data-testid="loading-spinner" width="100%" height="100%">
      <StyledCircularProgress />
    </StyledBox>
  );
}

export default PageLoadSpinner;
